module.exports = __webpack_public_path__ + "assets/retina_Angle30Detailed.8b2c2e038601022f906cbde1274fa900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle30Detailed.png
// module id = 613
// module chunks = 0